import { EmploymentPeriodStatusEnum, MarkupNew, MarkupStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';
import { DateRangeItemDetails, Headings } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

export const MarkupDateRangeItemDetail = ({
  headingComponent = 'H5',
  employmentPeriodStatus,
  markup,
  markupStatus,
  hasOnlyActiveMarkups,
}: {
  employmentPeriodStatus: EmploymentPeriodStatusEnum;
  headingComponent?: keyof typeof Headings;
  markup: MarkupNew;
  markupStatus: MarkupStatusEnum;
  hasOnlyActiveMarkups?: boolean;
}) => {
  const { t } = useTypedTranslation();

  const isEmploymentPeriodActive = employmentPeriodStatus === EmploymentPeriodStatusEnum.Active;

  const getMarkupText = () => {
    if (!isEmploymentPeriodActive || hasOnlyActiveMarkups) {
      return t('list.markupAndParametersList.unspecifiedMarkupTitle');
    }
    if (markupStatus === MarkupStatusEnum.Active) {
      return t('list.markupAndParametersList.activeTitle');
    }
    if (markupStatus === MarkupStatusEnum.Future) {
      return t('list.markupAndParametersList.futureTitle');
    }

    return t('list.markupAndParametersList.previousTitle');
  };

  return (
    <DateRangeItemDetails
      headingComponent={headingComponent}
      headingStyle="h5"
      title={getMarkupText()}
      subTitle={markup.fokText || `${markup.fokId} (${t('section.employmentDetails.fokTextMissing')}}))`}
      startDate={markup.startDate}
      endDate={markup.endDate}
    />
  );
};
